import { defineStore } from "pinia";

export const useAttributesStore = defineStore({
  id: "attributes",
  state: () => ({
    Mobile: true,
    Iphone: false,
    Ipad: false,
    DesktopOS: false,
    HasHover: false,
  }),
  getters: {
    isMobile: (state) => state.Mobile,
    isIphone: (state) => state.Iphone,
    isIpad: (state) => state.Ipad,
    isDesktopOS: (state) => state.DesktopOS,
    screenHasHover: (state) => state.HasHover,
  },
  actions: {
    setMobile(mobile: boolean) {
      this.Mobile = mobile;
    },
    setIphone(iphone: boolean) {
      this.Iphone = iphone;
    },
    setIpad(ipad: boolean) {
      this.Ipad = ipad;
    },
    setDesktopOS(desktopOS: boolean) {
      this.DesktopOS = desktopOS;
    },
    setScreenHasHover(hasHover: boolean) {
      this.HasHover = hasHover;
    },
  },
});
